import { distanceBetweenPoints, subtractPoints } from '../measurement-utils';
import { getMouseEventPoint } from '../mouse-event-utils';
import { getCenterPointOfTouchEvent } from '../touch-event-utils';
/**
 * Base class for handling mouse and touch inputs.
 * Contains common processing logic for panning.
 */
export class InputRecognizer {
    constructor() {
        this.panThreshold = 10;
        this.onPan = (onPanHandler) => (this.onPanHandler = onPanHandler);
    }
    handlePan(event) {
        var _a;
        const currentPanPoint = isTouchEvent(event) ? getCenterPointOfTouchEvent(event) : getMouseEventPoint(event);
        if (this.firstPanPoint === undefined) {
            this.firstPanPoint = currentPanPoint;
            return false;
        }
        const distanceFromFirstPanPoint = distanceBetweenPoints(currentPanPoint, this.firstPanPoint);
        const panDelta = subtractPoints(currentPanPoint, this.lastPanPoint || this.firstPanPoint);
        this.lastPanPoint = currentPanPoint;
        if (distanceFromFirstPanPoint >= this.panThreshold) {
            (_a = this.onPanHandler) === null || _a === void 0 ? void 0 : _a.call(this, panDelta);
            return true;
        }
        return false;
    }
    reset() {
        this.firstPanPoint = undefined;
        this.lastPanPoint = undefined;
    }
}
export function isTouchEvent(event) {
    return !!event.touches;
}
